import React, { useCallback } from 'react';
import { useOperationStore } from '../../../../../../stores/OperationStore';
import { isNotEmptyObject } from '../../../../../../utils/app-common';

interface IBindingHookProps {
  manifestFormRef: any
}

const BindingHook = ({ manifestFormRef }: IBindingHookProps) => {

  const manifestationList = useOperationStore((state) => state?.manifestationList);
  const selectedQuotation = useOperationStore(state => state?.selectedQuotation);
  const { agreementOdaPriceList } = manifestationList || {};
  const getBasePrice = useCallback((selectedId: number) => agreementOdaPriceList?.find(agreementOdaPrice => agreementOdaPrice?.odaId === selectedId)?.basePrice, [agreementOdaPriceList]);
  const bindingFunction = useCallback(() => {
    if (manifestationList && Object?.keys(manifestationList)?.length) {
      for (const [key, value] of Object.entries(manifestationList)) {
        if (["manifetDetail"].includes(key)) {
          for (const [manifestDetailKey, manifestDetailValue] of Object.entries(value)) {
            manifestFormRef.current.setFieldValue(manifestDetailKey, manifestDetailValue);
          }
        }
        if (key === 'originOdaCityId') {
          manifestFormRef.current.setFieldValue('originOdaCharge', getBasePrice(value));
        }
        if (key === 'destinationOdaCityId') {
          manifestFormRef.current.setFieldValue('destOdaCharge', getBasePrice(value));
        }
        manifestFormRef?.current?.setFieldValue(key, value);
      };
    }
  }, [manifestFormRef, manifestationList, getBasePrice])

  const internationalBinding = useCallback(() => {
    if (isNotEmptyObject(selectedQuotation) && selectedQuotation) {
      for (const [key, value] of Object.entries(selectedQuotation)) {
        manifestFormRef?.current?.setFieldValue(key, value);
      }
    }
  }, [selectedQuotation, manifestFormRef])
  React.useEffect(() => {
    bindingFunction()
    internationalBinding()
  }
    , [bindingFunction, internationalBinding])

};

export default BindingHook;
